import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Helmet } from "react-helmet";
import PageTitle from "components/PageTitle";
import { KEYS, RolesFilters, RolesList } from "components/Missions/Roles";
import { useAuth, useParamFunctions } from "hooks";
import { RolesSubscribeToggle } from "components/Missions/Roles";
import { Grid } from "components/Containers";
import { TUTORIAL_MISSIONS_KEYNAME, TutorialMissions } from "components/Tutorials";

/**
 * MissionBoard
 */
const MissionBoard = () => {
  const intl = useIntl();
  const [showTutorial, setShowTutorial] = useState(false);
  const { paramParse } = useParamFunctions();
  const parsedFilters = paramParse(KEYS.filters);
  const { isClient, isShowcase, isAdmin, isMember, preferences } = useAuth();
  const hideTutorial = isClient || isShowcase;

  useEffect(() => {
    setShowTutorial(preferences?.[TUTORIAL_MISSIONS_KEYNAME] === false ? false : true);
  }, [preferences?.[TUTORIAL_MISSIONS_KEYNAME]]);

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Missions.Board.Title" })}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle
            {...(isAdmin
              ? {
                  subtitle: <FormattedMessage id={`Missions.Board.H1`} />,
                }
              : {
                  title: <FormattedMessage id={`Missions.Board.H1`} />,
                })}
            actionBar={<RolesSubscribeToggle />}
          />
        </Grid.col>
        {showTutorial && !hideTutorial && (
          <Grid.col start={1} end={13}>
            <TutorialMissions handleToggle={setShowTutorial} />
          </Grid.col>
        )}
        <Grid.col start={1} end={13}>
          <RolesFilters
            hidePrimarySkillsFilter={false}
            hideDisciplinesFilter={false}
            hideTalentOwnerFilter
            hideSalesOwnerFilter
            hideStatusFilter
            hideKeywordSearch
          />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <RolesList
            isCardView={true}
            filters={{ published: true, ...parsedFilters }}
            messageProps={{
              title: "Missions.Roles.RolesList.EmptyTitle",
              description: `Missions.Roles.RolesList.${isMember ? `MemberEmpty` : `Empty`}`,
            }}
          />
        </Grid.col>
      </Grid>
    </>
  );
};

export default MissionBoard;
